import Banner from '@/components/Banner2';
import Profile from './components/Profile';
import Culture from './components/Culture';
import Process from './components/Process';
import Honour from './components/Honour';
import Contact from './components/Contact';
export default {
  components: {
    Banner,
    Profile,
    Culture,
    Process,
    Honour,
    Contact
  }
};